type AuthorizationsApiConfig = {
  baseUrl: string;
  getBearerToken: () => Promise<string>;
}

export const authorizationsApi = {
  get: async (config: AuthorizationsApiConfig): Promise<Response> => {
    let token = '';
    try {
      token = await config.getBearerToken();
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Unknown error';
      console.warn('Failed to retrieve bearer token:', message);
    }

    return fetch(new URL(`${config.baseUrl}/authorizations`), {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
};
